import { PUBLIC_STORE_ID } from '$env/static/public';

import { error } from '@sveltejs/kit';

import { getPaginatedSeoData, seoConfig } from '@shared/configs';
import { buildFilterPagePath, extendBreadcrumbsWithSlug } from '@shared/ui/breadcrumbs';

import { artworksPageApi } from '@pages/artworks';

import type { PageLoad } from './$types';

export const load: PageLoad = async ({ fetch, data }) => {
  const { loadMore, order, sort, page, parsedParams, filters } = data;

  const { artworks, totalCount } = await artworksPageApi.readData({
    fetch,
    page,
    loadMore,
    institutionId: Number(PUBLIC_STORE_ID),
    sort,
    order,
    ...parsedParams,
  });

  if (artworks.length === 0) {
    throw error(404, 'Page not found');
  }

  const extraPath = buildFilterPagePath({ baseUrl: '/artworks/', filters, page });

  const baseBreadcrumbs = [
    {
      name: 'Home',
      slug: '/',
      canonical: false,
    },
    {
      name: 'Artworks',
      slug: '/artworks/',
      canonical: !extraPath,
    },
  ];

  const breadcrumbs = extendBreadcrumbsWithSlug({
    baseBreadcrumbs,
    slug: extraPath,
    name: 'Artworks filters options',
  });

  const seoForPaginatedPage = getPaginatedSeoData({
    page,
    title: 'Artworks Section of the Ukrainian Fund of Digitized Art (UFDA)',
    metaDescription:
      'Discover and purchase unique digital originals from the Ukrainian Fund of Digitized Art (UFDA). Explore a curated collection of contemporary Ukrainian artworks, digitized and ready to own, supporting artists and cultural preservation.',
  });

  const seo = seoConfig.artworks({ breadcrumbs, robots: !filters, ...seoForPaginatedPage });

  return {
    artworks,
    totalCount,
    page,
    loadMore,
    seo,
  };
};
